import {
  Globe,
  Layers,
  ShieldCheck,
  Zap,
  Sparkles,
  Minimize2,
  Sliders,
  FileText,
  Edit3,
  MousePointerClick,
  Download,
  LayoutTemplate,
  FileCheck,
  RefreshCw,
  ImageIcon,
  Image,
} from 'lucide-react';

const iconMap = {
  Globe,
  Layers,
  ShieldCheck,
  Zap,
  Sparkles,
  Minimize2,
  Sliders,
  FileText,
  Edit3,
  MousePointerClick,
  Download,
  LayoutTemplate,
  FileCheck,
  RefreshCw,
  ImageIcon,
  Image,
};

export default function ToolIcon({ name, size = 20, className = '' }) {
  const Icon = iconMap[name] || Sparkles;
  return <Icon size={size} className={className} aria-hidden="true" />;
}
